<app-app-bar></app-app-bar>

<app-main-content>
  <div class="lens-page lens-hub">
    <section class="dash-container hub-header lens-banner">
      <div><h1 class="dash-section-head__title">CTBE</h1>
        <p class="dash-section-head__subtitle">Announcements and campus issue reporting in one place</p></div>
    </section>

    <div class="hub-layout">
    <div class="hub-content">
        <header class="dash-section-head dash-section-head--compact"><div><h2 class="dash-section-head__title">CTBE Announcements</h2></div>
          <span class="hub-announcements__count">{{ pinnedAnnouncements().length + filteredAnnouncements().length }} shown</span></header>
    <section class="dash-container hub-search">
      <label class="hub-search-bar">
        <mat-icon>search</mat-icon><span class="sr-only">Search announcements</span>
        <input type="search" placeholder="Search announcements…" [value]="searchQuery()" (input)="onSearch($event)" />
      </label>
    </section>

    @if (announcementsLoading()) {
    <section class="dash-container hub-state" aria-live="polite"><span class="hub-spinner"></span><p>Loading announcements…</p></section>
    } @else if (announcementsError()) {
    <section class="dash-container hub-state hub-state--error" role="alert">
      <mat-icon>cloud_off</mat-icon><h2>Announcements are unavailable</h2><p>Please try again later, or search for a specific announcement.</p>
      <button type="button" class="hub-feedback__btn" (click)="loadAnnouncements()">Try again</button>
    </section>
    } @else {
      @if (pinnedAnnouncements().length) {
      <section class="dash-container hub-pinned" aria-label="Pinned announcements">
        @for (item of pinnedAnnouncements(); track item.id) {
        <details class="hub-pinned-card hub-announcement-disclosure">
          <summary class="hub-announcement-summary">
            <mat-icon class="hub-pinned-card__icon" aria-hidden="true">bookmark</mat-icon>
            <span class="hub-pinned-card__title">{{ item.title }}</span>
            <mat-icon class="hub-announcement-chevron" aria-hidden="true">expand_more</mat-icon>
          </summary>
          <div class="hub-announcement-details">
            <span class="hub-pinned-card__label">Pinned announcement</span>
            <div class="hub-pinned-card__desc announcement-rich-content" [innerHTML]="item.content | announcementContent"></div>
            <time [attr.datetime]="item.publish_start">Published {{ item.publish_start | date:'mediumDate' }}</time>
          </div>
        </details>
        }
      </section>
      }

      <section class="dash-container hub-announcements" aria-label="CTBE announcements">
        <div class="dash-chips" role="tablist" aria-label="Announcement category">
          <button type="button" class="dash-chip" [class.dash-chip--active]="activeCategory() === 'all'"
            role="tab" [attr.aria-selected]="activeCategory() === 'all'" (click)="setCategory('all')">All</button>
          @for (category of categoryFilters(); track category.id) {
          <button type="button" class="dash-chip" [class.dash-chip--active]="activeCategory() === category.id"
            role="tab" [attr.aria-selected]="activeCategory() === category.id" (click)="setCategory(category.id)">{{ category.label }}</button>
          }
        </div>
        @if (filteredAnnouncements().length) {
        <div class="hub-announcement-list">
          @for (item of filteredAnnouncements(); track item.id) {
          <details class="hub-announcement-item hub-announcement-disclosure">
            <summary class="hub-announcement-summary">
              <span class="hub-announcement-item__icon"><mat-icon aria-hidden="true">{{ announcementIcon(item) }}</mat-icon></span>
              <span class="hub-announcement-item__title">{{ item.title }}</span>
              <mat-icon class="hub-announcement-chevron" aria-hidden="true">expand_more</mat-icon>
            </summary>
            <div class="hub-announcement-details">
              <div class="hub-announcement-item__text announcement-rich-content" [innerHTML]="item.content | announcementContent"></div>
              <span class="hub-announcement-item__meta">{{ categoryNames(item) }} · {{ item.publish_start | date:'mediumDate' }}</span>
            </div>
          </details>
          }
        </div>
        } @else {
        <div class="hub-empty"><mat-icon>notifications_off</mat-icon><p>No announcements match your search or filter.</p></div>
        }
      </section>
    }

    </div>
    <section class="dash-container hub-feedback" aria-label="Report a campus issue">
      <header class="dash-section-head dash-section-head--compact"><div><h2 class="dash-section-head__title">Report an issue to CTBE</h2>
        <p class="dash-section-head__subtitle">Choose the affected campus spot and the exact issue so it reaches the right team.</p></div></header>
      <button type="button" class="hub-feedback__btn" (click)="openReport()"><mat-icon>report_problem</mat-icon>Share your feedback</button>
    </section>
    </div>
  </div>
</app-main-content>



@if (reportOpen()) {
<div class="hub-scrim" (click)="closeReport()"></div>
<div class="hub-modal" role="dialog" aria-modal="true" aria-labelledby="report-title">
  <div class="hub-modal__head"><p id="report-title" class="hub-modal__title">Report an issue</p>
    <button type="button" class="hub-modal__close" aria-label="Close report form" (click)="closeReport()"><mat-icon>close</mat-icon></button></div>

  @if (submittedReport(); as report) {
  <div class="hub-report-success" role="status"><mat-icon>check_circle</mat-icon><h2>Report submitted</h2>
    <p>Report #{{ report.id }} is {{ report.status }} and has been sent to CTBE.</p></div>
  } @else if (reportOptionsLoading()) {
  <div class="hub-state"><span class="hub-spinner"></span><p>Loading reporting options…</p></div>
  } @else if (reportOptionsError()) {
  <div class="hub-state hub-state--error" role="alert"><mat-icon>cloud_off</mat-icon><p>Reporting options could not be loaded.</p>
    <button type="button" class="hub-feedback__btn" (click)="loadReportOptions()">Try again</button></div>
  } @else {
  <div class="hub-modal__form">
    <label class="hub-field"><span>Campus spot</span>
      <select [value]="selectedSpotId() ?? ''" (change)="selectedSpotId.set(+$any($event.target).value || null)">
        <option value="">Select a spot</option>@for (spot of spots(); track spot.id) {<option [value]="spot.id">{{ spot.commonName }}</option>}
      </select></label>
    <label class="hub-field"><span>Issue category</span>
      <select [value]="selectedIssueTypeId() ?? ''" (change)="selectIssueType(+$any($event.target).value)">
        <option value="">Select a category</option>@for (type of issueTypes(); track type.id) {<option [value]="type.id">{{ type.name }}</option>}
      </select></label>
    <label class="hub-field"><span>Issue</span>
      <select [disabled]="!selectedIssueTypeId() || issuesLoading()" [value]="selectedIssueId() ?? ''" (change)="selectedIssueId.set(+$any($event.target).value || null)">
        <option value="">{{ issuesLoading() ? 'Loading issues…' : 'Select an issue' }}</option>
        @for (issue of issues(); track issue.id) {<option [value]="issue.id">{{ issue.name }}</option>}
      </select></label>
    <label class="hub-field"><span>Details <small>(optional)</small></span>
      <textarea class="hub-modal__textarea" rows="4" maxlength="2000" placeholder="Add useful details…"
        [value]="reportComment()" (input)="onCommentChange($event)"></textarea></label>
    @if (submitError()) {<p class="hub-submit-error" role="alert">The request could not be completed. Please try again.</p>}
    <button type="button" class="hub-modal__submit" [disabled]="!canSubmit()" (click)="submitReport()">
      {{ submitting() ? 'Submitting…' : 'Submit report' }}</button>
  </div>
  }
</div>
}
